export default __webpack_public_path__ + "static/media/yorubaland.10e1fe6c.svg";